module.exports = __webpack_public_path__ + "static/media/ic_check_success.5f906df9.svg";